import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { Colors } from '../../../../themes/colors';
import { TabViewContainer } from '../../../commonComponents/TabViewContainer';
import { Table } from '../../../commonComponents/Table/Table';
import { getAdminRamUser } from '../../../../actions/userActions';
import { fetchRequestedEducations } from '../../../../actions/licensesAction';
import { Filters } from './components/Filters';
import { useJobList } from '../../../../domain/Jobs/useCases';
import { JobType } from '../../../../domain/Jobs/enums/JobType';
import { jobListColumn, jobListConditionalRowStyles } from '../../../commonComponents/jobs-column';
import { createLoadingSelector } from '../../../../apis/selectors';
import SynchronizeIcon from '../../../../images/synchronize.png';
import Styles from '../../../../themes/style.module.scss';

const getJobUrl = (job) => `/job/${job.id}`;
const getUserUrl = (userId, userType) => `/user/${userType.toLowerCase()}/${userId}`;

const loadingSelector = createLoadingSelector(['GET_ADMIN_RAM', 'GET_DSO_NAMES']);

export const OnsiteInterviewList = () => {
  const dispatch = useDispatch();

  const isInitialLoading = useSelector((state) => loadingSelector(state));

  useEffect(() => {
    dispatch(getAdminRamUser());
    dispatch(fetchRequestedEducations());
  }, [dispatch]);

  const {
    data,
    isLoading,
    isFetching,
    filters,
    total,
    totalFiltered,
    totalPages,
    handleFilterChanged,
    handlePageChanged,
    handleSortChanged,
    reloadJobs,
  } = useJobList({ jobType: JobType.INTERVIEW });
  const getColumn = () =>
    jobListColumn({
      getUserUrl,
      getJobUrl,
      showCounterExpiration: ['pending', 'counter', 'pending-counter'].includes(filters?.jobStatus),
      cancellationTime: true,
      isOnsiteInterview: true,
    });

  if (isInitialLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
        <Spinner
          animation="border"
          role="status"
          variant="info"
          style={{
            height: 30,
            width: 30,
            marginLeft: 20,
            marginTop: 10,
          }}
        />
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        height: '100vh',
        overflowY: 'auto',
        flexDirection: 'column',
        position: 'relative',
        alignItems: 'center',
      }}
    >
      <TabViewContainer style={{ marginInline: 'auto', width: '95%', marginTop: 0 }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <h3 className={Styles.h3} style={{ fontSize: '24px', textAlign: 'center' }}>
            Interviews
          </h3>
          {isFetching ? (
            <div>
              <Spinner
                animation="border"
                role="status"
                variant="info"
                style={{
                  height: 30,
                  width: 30,
                  marginLeft: 20,
                  marginTop: 10,
                }}
              />
            </div>
          ) : (
            <div>
              <img
                src={SynchronizeIcon}
                width="38px"
                height="38px"
                className={Styles.dashboardUserIcon}
                onClick={reloadJobs}
                alt="reload action"
              />
            </div>
          )}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Filters filters={filters} handleFilterChanged={handleFilterChanged} />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end',
              alignItems: 'flex-end',
            }}
          >
            <span
              style={{
                fontSize: 20,
                fontWeight: 'bold',
                color: Colors.neutral_600,
              }}
            >
              Total | {total !== undefined ? Intl.NumberFormat().format(total) : ''}
            </span>
            <span
              style={{
                fontSize: 20,
                fontWeight: 'bold',
                color: Colors.neutral_600,
              }}
            >
              Total {filters.jobStatus || 'all'} |{' '}
              {totalFiltered !== undefined ? Intl.NumberFormat().format(totalFiltered) : ''}
            </span>
          </div>
        </div>
        <TabViewContainer style={{ margin: 0, padding: 20 }}>
          <Table
            initialPage={filters.page}
            columns={getColumn()}
            data={data}
            noDataComponent="There are no Interviews"
            isLoading={isLoading}
            totalPages={totalPages}
            showTotal={false}
            onSort={handleSortChanged}
            paginationPerPage={filters.limit}
            paginationTotalRows={totalFiltered}
            onPageChange={handlePageChanged}
            conditionalRowStyles={jobListConditionalRowStyles}
            forceLoading={isLoading}
          />
        </TabViewContainer>
      </TabViewContainer>
    </div>
  );
};
